import { Routes, Route } from 'react-router-dom'

import pathUtils from 'utils/pathUtils'
import ExternalResumeDetail from 'views/application/external_resumes/detail'
import ExternalResumesOverview from 'views/application/external_resumes/overview'

const routes = [
  {
    path: pathUtils.EXTERNAL_RESUMES_OVERVIEW,
    element: <ExternalResumesOverview />,
  },
  {
    path: pathUtils.EXTERNAL_RESUMES_DETAIL,
    element: <ExternalResumeDetail />,
  },
]

const ExternalResumesRoutes: React.FC = () => {
  return (
    <Routes>
      {routes.map((route, index) => (
        <Route key={index} {...route} />
      ))}
    </Routes>
  )
}

export default ExternalResumesRoutes
